"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAVChallengeInfo = void 0;
var conversions_1 = require("../../../../utils/conversions");
// eslint-disable-next-line import/prefer-default-export
var parseAVChallengeInfo = function (dataView) {
    var _a, _b;
    var serialNumber = (_a = dataView === null || dataView === void 0 ? void 0 : dataView.buffer) === null || _a === void 0 ? void 0 : _a.slice(0, 12);
    var randomData = (_b = dataView === null || dataView === void 0 ? void 0 : dataView.buffer) === null || _b === void 0 ? void 0 : _b.slice(12, 32);
    return {
        device_id: serialNumber !== undefined && (0, conversions_1.buf2hex)(serialNumber),
        random_data: randomData !== undefined && (0, conversions_1.buf2hex)(randomData)
    };
};
exports.parseAVChallengeInfo = parseAVChallengeInfo;
